<script>
import PartCard from "@/components/atoms/PartCard";
import * as Units from '@/lib/units';
import * as Id from '@/lib/id';
import Btn from "@/components/atoms/Btn";
import In from "@/components/atoms/In";
import Banner from "@/components/atoms/Banner";

export default {
  components: { Banner, PartCard, Btn, In },
  mounted(){
    console.log(this.part);
  },
  data(){
    return {
      quantity: 1,
      length: null,
      width: null
    }
  },
  computed: {
    part(){
      // this.$gtag.event('view_part', {'event_category': 'flow', 'event_label': this.$route.params.part_id});
      return this.$store.get("parts/partById",this.$route.params.part_id)
    },
    price(){
      return Units.getPriceLabel(this.part.price);
    },
    discount(){
      return Units.getPriceDiscount(this.part.price);
    },
    details(){
      const details = Object.keys(this.part.details).filter(key => (
        key.trim().split(" ")[0].length > 3
      )).sort((a,b) => this.toTitleCase(a) < this.toTitleCase(b) ? -1 : 1).reduce(
        (obj, key) => { 
          obj[key] = this.part.details[key]; 
          return obj;
        }, 
        {}
      );
      return details;
    },
    spec(){
      const spec = Object.keys(this.part.details).filter(key => (
        key.trim().split(" ")[0].length <= 3
      )).sort((a,b) => this.toTitleCase(a) < this.toTitleCase(b) ? -1 : 1).reduce(
        (obj, key) => { 
          obj[key] = this.part.details[key]; 
          return obj;
        }, 
        {}
      );
      return spec;
    },
    image_url(){
      return Id.getPartImageURL(this.part.id)
    },
    diagram_url(){
      return Id.getPartDiagramURL(this.part.id)
    },
    needsLength(){
      return this.part.categories.includes('Panels') || this.part.categories.includes('T-SlottedProfiles')
    },
    needsWidth(){
      return this.part.categories.includes('Panels')
    }
  },
  methods:{
    // getForwardLink(relatedPartId){
    //   if(this.$route.params.part_id_1){
    //     return '/parts/categories/'+this.$route.params.part_category+'/.../'+this.$route.params.part_id+'/'+relatedPartId
    //   }else{
    //     return '/parts/categories/'+this.$route.params.part_category+'/'+this.$route.params.part_id+'/'+relatedPartId
    //   }
    // },
    // getBackwardLink(){
    //   if(this.$route.params.part_id_1){
    //     return '/parts/categories/'+this.$route.params.part_category+'/'+this.$route.params.part_id_1
    //   }else{
    //     return '/parts/categories/'+this.$route.params.part_category
    //   }
    // },
    goBack(){
      this.$router.go(-1);
    },
    toTitleCase(value){
      var sentence = value.trim().toLowerCase().split("_");
      for(var i = 0; i< sentence.length; i++){
         sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
      }
      return sentence.join(" ");
    },
    addToCart(){
      const ledgerPart = this.getLedgerPart();
      if(ledgerPart){
        this.$store.dispatch("payment/getOrderFromLedger", [ledgerPart]).then(order => {
        if(this.$store.get('payment/pendingOrder')){
          this.$store.dispatch('payment/pendingOrder', {
            ...this.$store.get('payment/pendingOrder'),
            ledger: [...this.$store.get('payment/pendingOrder').ledger, ...order.ledger]
          });
        }else{
          this.$store.dispatch('payment/pendingOrder', order);
        }
        this.$toast("Added to Cart!", {
          type: "success",
        });
      });
      }
    },
    getLedgerPart(){
      let ledgerPart = {
        id: this.part.id,
        quantity: this.quantity,
        width: 0, 
        height: 0,
        length: 0,
        customWidth: false,
        customHeight: false,
        customLength: false,
        requiredMachining: [],
      }
      if(this.needsLength){
        let lengthInMeters = this.part.metric ? parseFloat(this.length) * 0.01 : parseFloat(this.length) * 0.0254;
        if(!lengthInMeters){
          this.$toast("Requires Length", {
            type: "error",
          });
          return null;
        }else if(lengthInMeters < 0.0254){
          this.$toast("Length must be at least 1in", {
            type: "error",
          });
          return null;
        }else if(lengthInMeters > 2.3368){
          this.$toast("Length must be less than 92in", {
            type: "error",
          });
          return null;
        }else{
          ledgerPart.length = lengthInMeters;
          ledgerPart.customLength = true;
        }

        if(this.needsWidth){
          let widthInMeters = this.part.metric ? parseFloat(this.width) * 0.01 : parseFloat(this.width) * 0.0254;
          if(!widthInMeters){
            this.$toast("Requires Width", {
              type: "error",
            });
            return null;
          }else if(widthInMeters < 0.0254){
            this.$toast("Width must be at least 1in", {
              type: "error",
            });
            return null;
          }else if(widthInMeters > 2.3368){
            this.$toast("Width must be less than 92in", {
              type: "error",
            });
            return null;
          }else{
            ledgerPart.width = widthInMeters;
            ledgerPart.customWidth = true;
          }
        }
      }else{
        let maxLength = 0;
        Object.keys(this.part.details).filter(key => key.length <= 3).forEach(key => {
          let val = parseFloat(this.part.details[key]);
          if(this.part.metric){
            if(this.part.details[key].toLowerCase().includes("mm")){
              val = val * 0.001;
            }else if(this.part.details[key].toLowerCase().includes("cm")){
              val = val * 0.01;
            }
          }else{
            if(this.part.details[key].toLowerCase().includes("ft")){
              val = val * 0.3048;
            }else{
              val = val * 0.0254;
            }
          }
          if(val > maxLength){
            maxLength = val;
          }
        })
        ledgerPart.length = maxLength;
      }
      return ledgerPart;
    }
  },
};
</script>


<template>
  <div id="part-page">
    <Banner>
      <div class="part-details" v-if="part">
        <div class="limiter">
          <div class="back" @click="goBack()">
            <i class="fas fa-chevron-left fa-sm"></i> Back
          </div>
          <div class="part">
            <div class="part-area">
              <div class="grab-indicator" >
                <img class="grab" :src="'./icons/hand-sparkles-regular.svg'" />
                <div class="grab-text">Grab</div>
              </div>
              <div class="left-col" :data-vr="part.id">
                <div class="part-image" :style="part.image ? part.image.style : {}">
                  <img :src="image_url" />
                  <span v-if="part.details && part.details['Series']" class="series-label" :class="{metric: part.metric, ...part.details['Series'].split(',').reduce((acc, val) => ({...acc, ['s'+val.trim().replace('Series', '')]: true}), {})}">
                    {{part.details['Series'].replace(", Ready Tube", "").replaceAll(" Series", "")+" Series"}}
                  </span> 
                </div>
              </div>
              <div class="right-col">
                <div class="title-row">
                  <div class="part-name">
                    <div class="name">
                      {{part.name}} <span v-if="part.sub_name">{{part.sub_name}}</span>
                    </div>
                  </div>
                </div>
                <div class="id">
                  {{part.id}}
                </div>
                <div class="price">
                  <span class="highlight" v-if="discount">{{discount}}</span>
                  <span>{{ price }}</span>
                </div>
                <div class="add-to-order" v-if="price && price!= '--'">
                  <in v-if="needsWidth" v-model="width" :placeholder="part.metric ? 'length (cm)' : 'width (in)'" type="number" size="medium"></in>
                  <in v-if="needsLength" v-model="length" :placeholder="part.metric ? 'length (cm)' : 'length (in)'" type="number" size="medium"></in>
                  <in v-model="quantity" placeholder="qty" type="number" size="small"></in>
                  <btn type="fill" @click="addToCart">Add to Cart</btn>
                </div>
                <div class="part-description" v-if="part.description && part.description != 'null'">
                  {{part.description}}
                </div>
              </div>
            </div>
            <div class="vendors" v-if="false">
              <span v-for="(key, index) in Object.keys(part.vendors)" :key="index">
                <a v-for="(link, i) in part.vendors[key].links" :key="i" :href="link" target="_blank" @click="track(link)">{{part.vendors[key].name}}</a>
              </span>
            </div>
          </div>
          <div class="diagram-title">
            Details
          </div>
          <div class="details">
            <div v-for="(key, index) in Object.keys(details)" :key="index" class="detail" v-if="details[key] != null">
              <div class="label">
                {{toTitleCase(key)}}
              </div>
              <div class="value" v-if="Array.isArray(details[key])">
                {{details[key].reduce((acc, val, index) => index == details[key].length - 1 ? acc + val : acc + val + ", ", "")}}
              </div>
              <div class="value" v-else>
                {{details[key]}}
              </div>
            </div>
          </div>
          <div class="diagram-title" v-if="false">
            {{part.metric ? "Dimensions:" : "Dimensions (in):"}}
          </div>
          <div class="diagram" v-if="false">
            <div class="right-col">
              <img :src="diagram_url" />
            </div>
            <div class="left-col" v-if="Object.keys(spec).length > 0">
              <div class="details">
                <div v-for="(key, index) in Object.keys(spec)" :key="index" class="detail" v-if="part.details[key] != null">
                  <div class="label">
                    {{toTitleCase(key)}}
                  </div>
                  <div class="value" v-if="Array.isArray(part.details[key])">
                    {{part.details[key].reduce((acc, val, index) => index == part.details[key].length - 1 ? acc + val : acc + val + ", ", "")}}
                  </div>
                  <div class="value" v-else>
                    {{part.details[key]}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="diagram-title">
            Related Parts
          </div>
          <div class="realted-parts">
            <div class="card-area">
              <PartCard
                v-for="(relatedPartId, index) in part.related_parts"
                :key="index"
                :part="$store.get('parts/partById', relatedPartId)"
                :link="this.$router.currentRoute.fullPath.split('/id/')[0]+'/id/'+part.id"
              />
            </div>
          </div>
        </div>
      </div>
    </Banner>
  </div>
  
</template>

<style lang="scss" scoped>
@import "~@/styles/constants";
.part-details { 
  padding: 1rem 1.5rem;
  background-color: $black_2;
  display: flex;
  justify-content: center;
  align-items: stretch;
  min-height: 100%;
  .limiter{
    flex-basis: 90rem;
    padding-bottom: 4rem;
  }
  .back{
    font-size: 1.5rem;
    margin: 0rem 2.5rem;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    border-radius: 4px;
    i{
      margin-right: 0.5rem;
    }
    &:hover, &.hover{
      background-color: $black_3;
      cursor: pointer;
      .back{
        top: 2rem;
        font-size: 2rem;
      }
      .name{
        opacity: 0;
      }
    }
  }
  .title-row{
    padding: 0rem 2rem 1rem 2rem;
    .part-name { 
      display: inline-block;
      position: relative;
      padding: 0.5rem 1.5rem 1rem 1.5rem;
      border-radius: 0.5rem;
      .name{
        font-size: 2rem;
        opacity: 1;
        transition: all 0.3s ease;
      }
    }
  }
  .id{
    padding: 0rem 3rem 0.5rem 3rem;
    font-size: 1.25rem;
    color: $w_1;
  }
  .price{
    padding: 0rem 3rem 1.5rem 3rem;
    font-size: 2rem;
    .highlight{
      color: #20D983;
      margin-right: 0.5rem;
      // font-size: 1.25rem;
    }
  }
	.part { 
    padding: 0rem 1rem 0.5rem 1rem;
    .part-area{
      display: flex;
      align-items: flex-start;
      padding: 0.5rem 0.25rem 0.25rem 0.25rem;
      position: relative;
      &:hover, &.hover{
        .grab-indicator{
          // opacity: 1;
        }
      }
    }
    .grab-indicator{
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      pointer-events: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: rgba(178, 99, 247,0.4);
      z-index: 1;
      opacity: 0;
      transition: all 0.3s ease;
      border-radius: 0.5rem;
      .grab{
        width: 8rem;
      }
      .grab-text{
        margin-top: 1rem;
        font-size: 3.5rem;
      }
    }
		.left-col { 
      padding: 0rem 0rem;
      * {
        pointer-events: none;
      }
			.part-image { 
        width: 30rem;
        height: 30rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1.5rem;
        margin-bottom: 1rem;
        position: relative;
        border: 2px solid $black_3;
        border-radius: 0.5rem;
				img { 
          max-width: 100%;
          max-height: 100%
				}
        .series-label{
          position: absolute;
          top: 1rem;
          left: -0.5rem;
          padding: 0.25rem 1rem;
          background-color: $black_0;
          display: flex;
          align-items: center;
          font-size: 1.25rem;
          border-radius: 2px 2px 2px 2px;
          margin-left: -0.5rem;
        }
        
			}
		}

		.right-col { 
      .add-to-order{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0rem 0rem 1rem 3rem;
        .input{
          margin-right: 1rem;
        }
      }
		}
	}
  .details { 
    padding: 1rem 3rem 0rem 3rem;
    .detail { 
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 0.5rem 2rem;
      &:nth-child(odd){
        background-color: $black_3;
      }
      .label { 
        font-size: 1.25rem;
        margin-bottom: 0.25rem;
        color: $w;
        width: 18rem;
      }
      .value { 
        font-size: 1.25rem;
        color: $w;
      }
    }
  }
  .vendors{
    padding: 1rem;
    a{
      font-size: 1.25rem;
      color: #FFF;
      padding: 1rem;
    }
  }
  .part-description{
    display: flex;
    font-size: 1.5rem;
    font-weight: 500;
    // justify-content: center;
    padding: 1rem 3rem;
    color: $w;
  }
  .diagram-title{
    margin: 2rem 3rem 0rem 3rem;
    padding: 1.5rem 2rem 0.5rem 2rem;
    font-size: 1.75rem;
    // margin-bottom: 1.5rem;
    color: $w_1;
    border-top: 2px solid $black_3;
  }
  .diagram{
    // background-color: #FFF;
    display: flex;
    // justify-content: center;
    // padding: 0rem 5rem;
    .right-col{
      flex-basis: 55%;
      padding: 0rem 4rem;
      img{
        filter: invert(1);
        width: 100%;
      }
    }
    .left-col{
      // padding: 4rem;
      flex-basis: 45%;
      .details{
        .detail{
          .label{
            width: 10rem;
          }
        }
      }
    }
  }
  .realted-parts{
    padding: 2rem;
    .realted-parts-title{
      padding: 0rem 0.5rem;
      font-size: 1.5rem;
    }
    .card-area{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 1rem 0rem 2rem 0rem;
      margin-bottom: 2rem;
    }
  }
}
</style>